import { motion } from "framer-motion";

export default function Ambient() {
  return (
    <div className="fixed inset-0 z-[1] pointer-events-none overflow-hidden" aria-hidden="true">
      <motion.div
        className="absolute -top-32 -right-[10%] w-[46rem] h-[46rem] rounded-full bg-gold/[0.05] blur-3xl"
        animate={{ x: [0, -50, 20, 0], y: [0, 40, 10, 0], scale: [1, 1.08, 0.96, 1] }}
        transition={{ duration: 38, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="absolute -bottom-[15%] -left-[12%] w-[40rem] h-[40rem] rounded-full bg-bronze/[0.045] blur-3xl"
        animate={{ x: [0, 60, -15, 0], y: [0, -35, -5, 0], scale: [1, 0.94, 1.06, 1] }}
        transition={{ duration: 46, repeat: Infinity, ease: "easeInOut" }}
      />
    </div>
  );
}
